import React from "react";

export default ({ size = "m"}) => (
    <div className="preloader">
        <div className='sk-three-bounce'>
            <div className={`sk-bounce-1 sk-child--${size}`}></div>
            <div className={`sk-bounce-2 sk-child--${size}`}></div>
            <div className={`sk-bounce-3 sk-child--${size}`}></div>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/Preloader.js